import React, { useEffect, useState } from "react";

import axios from "axios";

import { Form, Input, InputNumber, Select, message } from "antd";

import { useNavigate, useParams } from "react-router-dom";

import Layout from "./Layout";



const { Option } = Select;

const COLOR = { blue:"#1e40af", blueLt:"#3b82f6", text:"#1e293b", textMid:"#475569", border:"#e2e8f0", green:"#16a34a", greenLt:"#22c55e" };

const FF = "'Segoe UI', system-ui, sans-serif"; const FS = "13.5px";

const BASE_URL = `${process.env.REACT_APP_API_URL}/raiseFeeDemand`;



const EditFee = () => {

  const { id } = useParams(); // document id (record.id)

  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const [editData, setEditData] = useState(null);

  // Underlying entries as loaded: [{ feeIndex, studentType, medium }]

  const [entries, setEntries] = useState([]);



  useEffect(() => {

    const stored = sessionStorage.getItem("editFeeData");

    if (!stored) {

      message.error("No edit data found.");

      navigate("/feeDemand");

      return;

    }

    const p = JSON.parse(stored);

    setEditData(p);



    const list = p.entries?.length

      ? p.entries

      : [{ feeIndex: p.feeIndex, studentType: p.studentType, medium: p.medium }];

    setEntries(list);



    // Generic, shape-agnostic extraction: walk the entire stored object and

    // collect every string value under any key that looks like

    // "studentType(s)" or "medium(s)", wherever it's nested. This works no

    // matter which version of feeStructure.js produced the payload.

    const collectByKeyPattern = (obj, pattern, acc = new Set()) => {

      if (obj == null) return acc;

      if (Array.isArray(obj)) {

        obj.forEach((item) => collectByKeyPattern(item, pattern, acc));

        return acc;

      }

      if (typeof obj === "object") {

        Object.entries(obj).forEach(([key, val]) => {

          if (pattern.test(key)) {

            if (typeof val === "string") {

              val.split(",").map((v) => v.trim()).filter(Boolean).forEach((v) => acc.add(v));

            } else if (Array.isArray(val)) {

              val.forEach((v) => {

                if (typeof v === "string") {

                  v.split(",").map((x) => x.trim()).filter(Boolean).forEach((x) => acc.add(x));

                }

              });

            }

          } else if (typeof val === "object") {

            collectByKeyPattern(val, pattern, acc);

          }

        });

      }

      return acc;

    };



    let uniqueStudentTypes = [...collectByKeyPattern(p, /studentType/i)];

    let uniqueMediums = [...collectByKeyPattern(p, /medium/i)];



    // Keep only values that actually match the known options, in case the

    // scan above picked up unrelated text.

    const KNOWN_STUDENT_TYPES = ["New", "Old"];

    const KNOWN_MEDIUMS = ["Tamil", "English"];

    uniqueStudentTypes = uniqueStudentTypes.filter((v) =>

      KNOWN_STUDENT_TYPES.some((k) => k.toLowerCase() === v.toLowerCase())

    ).map((v) => KNOWN_STUDENT_TYPES.find((k) => k.toLowerCase() === v.toLowerCase()));

    uniqueMediums = uniqueMediums.filter((v) =>

      KNOWN_MEDIUMS.some((k) => k.toLowerCase() === v.toLowerCase())

    ).map((v) => KNOWN_MEDIUMS.find((k) => k.toLowerCase() === v.toLowerCase()));



    uniqueStudentTypes = [...new Set(uniqueStudentTypes)];

    uniqueMediums = [...new Set(uniqueMediums)];



    form.setFieldsValue({

      grade: p.grade === "—" ? "" : p.grade,

      type: p.type === "—" ? undefined : p.type,

      description: p.description === "—" ? "" : p.description,

      amount: p.amount,

      studentType: uniqueStudentTypes,

      medium: uniqueMediums,

    });

  }, []); // eslint-disable-line



  const handleSubmit = async (values) => {

    if (!editData || !entries.length) return;



    const selectedTypes = values.studentType || [];

    const selectedMediums = values.medium || [];

    if (!selectedTypes.length || !selectedMediums.length) {

      message.error("Select at least one Student Type and Medium");

      return;

    }



    setLoading(true);

    try {

      // ── Legacy compact row: everything lives in ONE raw entry, whose

      // studentType/medium fields are themselves comma-joined strings

      // (e.g. "New,Old"). Just write the new selections back the same way —

      // no combo explosion, no capacity limit.

      if (entries.length === 1) {

        await axios.put(`${BASE_URL}/updateFeeDemand/${id}`, {

          feeIndex: entries[0].feeIndex,

          grade: values.grade,

          type: values.type,

          description: values.description,

          amount: values.amount,

          studentType: selectedTypes.join(","),

          medium: selectedMediums.join(","),

        });

      } else {

        // ── True multi-entry row (from merging separate DB rows): each

        // entry holds exactly one (Student Type, Medium) combo.

        //

        // Diff by COMBO, not by feeIndex slot:

        //   - combo exists in both old & new selection  -> update in place

        //   - combo only in old selection                -> delete (removed by user)

        //   - combo only in new selection                -> add as a brand new entry

        // This lets the user freely add extra combos (e.g. add "Old") and

        // drop others (e.g. remove "English") in the same save, with no

        // artificial cap on how many combos the row can hold.

        const desired = [];

        selectedTypes.forEach((st) =>

          selectedMediums.forEach((md) => desired.push({ studentType: st, medium: md }))

        );



        const comboKey = (st, md) => `${st}|${md}`;

        const existingByCombo = new Map(

          entries.map((e) => [comboKey(e.studentType, e.medium), e.feeIndex])

        );

        const desiredKeys = new Set(desired.map((c) => comboKey(c.studentType, c.medium)));



        const toUpdate = desired.filter((c) => existingByCombo.has(comboKey(c.studentType, c.medium)));

        const toAdd = desired.filter((c) => !existingByCombo.has(comboKey(c.studentType, c.medium)));

        const toDeleteFeeIndexes = entries

          .map((e) => e.feeIndex)

          .filter((fi) => {

            const entry = entries.find((e) => e.feeIndex === fi);

            return !desiredKeys.has(comboKey(entry.studentType, entry.medium));

          });



        // Run sequentially — concurrent PUT/DELETE calls against the same

        // fee_details array can race and clobber each other's writes.



        // 1) Update combos that still exist (grade/type/description/amount may have changed)

        for (const combo of toUpdate) {

          const feeIndex = existingByCombo.get(comboKey(combo.studentType, combo.medium));

          await axios.put(`${BASE_URL}/updateFeeDemand/${id}`, {

            feeIndex,

            grade: values.grade,

            type: values.type,

            description: values.description,

            amount: values.amount,

            studentType: combo.studentType,

            medium: combo.medium,

          });

        }



        // 2) Delete combos the user removed — highest feeIndex first so

        //    earlier indexes don't shift while later deletes are pending.

        const sortedToDelete = [...toDeleteFeeIndexes].sort((a, b) => b - a);

        for (const feeIndex of sortedToDelete) {

          await axios.delete(`${BASE_URL}/deleteFeeEntry/${id}?feeIndex=${feeIndex}`);

        }



        // 3) Add brand new combos the user selected

        for (const combo of toAdd) {

          await axios.post(`${BASE_URL}/addFeeEntry/${id}`, {

            grade: values.grade,

            type: values.type,

            description: values.description,

            amount: values.amount,

            studentType: combo.studentType,

            medium: combo.medium,

          });

        }

      }



      sessionStorage.removeItem("editFeeData");

      message.success("Fee updated!");

      navigate("/feeDemand");

    } catch (err) {

      message.error(err.response?.data?.message || "Failed to update fee");

    } finally {

      setLoading(false);

    }

  };



  const inp = { fontFamily: FF, fontSize: FS };



  return (

    <Layout>

      <div className="app-page" style={{ fontFamily: FF }}>

        <div style={{ marginBottom: 28 }}>

          <h1 style={{ fontSize: 22, fontWeight: 700, color: COLOR.text, margin: 0, letterSpacing: "-0.3px" }}>

            Edit Fee Entry

          </h1>

          <div style={{ width: 40, height: 3, background: COLOR.blueLt, borderRadius: 2, marginTop: 6 }} />

          {editData?.academicYear && (

            <p style={{ fontSize: "13px", color: COLOR.textMid, marginTop: 8 }}>

              Academic Year: <strong>{editData.academicYear}</strong>

            </p>

          )}

        </div>



        <div style={{ maxWidth: 540, margin: "0 auto", background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.07)", border: `1px solid ${COLOR.border}`, padding: "28px 32px" }}>

          <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ fontFamily: FF }}>

            <Form.Item label="Grade" name="grade" rules={[{ required: true, message: "Enter grade" }]}>

              <Input placeholder="e.g. XI" style={inp} />

            </Form.Item>

            <Form.Item label="Fee Type" name="type" rules={[{ required: true, message: "Enter fee type" }]}>

              <Input placeholder="e.g. Management - Tuition Fee, PTA" style={inp} />

            </Form.Item>

            <Form.Item

              label="Student Type"

              name="studentType"

              rules={[{ required: true, message: "Select at least one student type" }]}

              extra="Select both New and Old to apply to all students"

            >

              <Select mode="multiple" placeholder="Select student type(s)" style={{ width: "100%", ...inp }}>

                <Option value="New">New</Option>

                <Option value="Old">Old</Option>

              </Select>

            </Form.Item>

            <Form.Item

              label="Medium"

              name="medium"

              rules={[{ required: true, message: "Select at least one medium" }]}

              extra="Select both Tamil and English to apply to all mediums"

            >

              <Select mode="multiple" placeholder="Select medium(s)" style={{ width: "100%", ...inp }}>

                <Option value="Tamil">Tamil</Option>

                <Option value="English">English</Option>

              </Select>

            </Form.Item>

            <Form.Item label="Description" name="description">

              <Input placeholder="Enter description" style={inp} />

            </Form.Item>

            <Form.Item label="Amount" name="amount" rules={[{ required: true, message: "Enter amount" }]}>

              <InputNumber min={0} style={{ width: "100%", ...inp }} placeholder="Enter amount" />

            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>

              <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>

                <button

                  type="button"

                  onClick={() => { sessionStorage.removeItem("editFeeData"); navigate("/feeDemand"); }}

                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}

                  onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}

                  style={{ all: "unset", padding: "9px 28px", borderRadius: 8, border: `1px solid ${COLOR.border}`, fontSize: FS, fontWeight: 600, color: COLOR.textMid, cursor: "pointer", background: "#fff", transition: "background 0.15s" }}

                >

                  Cancel

                </button>

                <button

                  type="submit"

                  disabled={loading}

                  onMouseEnter={(e) => (e.currentTarget.style.background = COLOR.green)}

                  onMouseLeave={(e) => (e.currentTarget.style.background = COLOR.greenLt)}

                  style={{ all: "unset", padding: "9px 28px", borderRadius: 8, background: COLOR.greenLt, color: "#fff", fontSize: FS, fontWeight: 600, cursor: "pointer", boxShadow: "0 2px 8px rgba(34,197,94,0.25)", transition: "all 0.18s" }}

                >

                  {loading ? "Saving..." : "Update Fee"}

                </button>

              </div>

            </Form.Item>

          </Form>

        </div>

      </div>

    </Layout>

  );

};



export default EditFee;

